/* HALO Studios — theme.js
   Uses Shopify's native Cart AJAX API (/cart/add.js, /cart/change.js, /cart.js)
   and the Predictive Search API (routes.predictive_search_url). No fake data,
   no fake checkout: the checkout button submits the real cart form to
   routes.cart_url so Shopify's own checkout takes over. */
(function(){
  'use strict';
  var $ = function(s, r){ return (r||document).querySelector(s); };
  var $$ = function(s, r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };
  var reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  var settingsEl = document.getElementById('CartSettings');
  var CART_SETTINGS = settingsEl ? JSON.parse(settingsEl.textContent) : {};

  /* ---------------- Dialog helpers ---------------- */
  var lastFocus = null;
  function openDialog(id){
    var d = document.getElementById(id);
    if(!d || d.open) return;
    lastFocus = document.activeElement;
    d.showModal();
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ d.classList.add('in'); }); });
    if(id === 'SearchOverlay'){ var input = $('#PredictiveSearchInput'); if(input) setTimeout(function(){ input.focus(); }, 50); }
  }
  function closeDialog(d){
    if(!d || !d.open) return;
    d.classList.remove('in');
    setTimeout(function(){
      d.close();
      if(!$$('dialog[open]').length) document.body.style.overflow = '';
      if(lastFocus && lastFocus.focus){ try{ lastFocus.focus(); }catch(e){} }
    }, reduceMotion ? 0 : 320);
  }
  $$('dialog').forEach(function(d){
    d.addEventListener('cancel', function(e){ e.preventDefault(); closeDialog(d); });
    d.addEventListener('click', function(e){ if(e.target === d) closeDialog(d); });
  });
  document.addEventListener('click', function(e){
    var openBtn = e.target.closest('[data-open]');
    var closeBtn = e.target.closest('[data-close]');
    if(closeBtn){ closeDialog(closeBtn.closest('dialog')); }
    if(openBtn){ openDialog(openBtn.dataset.open); }
  });
  $$('[data-cart-open]').forEach(function(b){ b.addEventListener('click', function(){ openDialog('CartDrawer'); }); });
  $$('[data-predictive-search-open]').forEach(function(b){ b.addEventListener('click', function(){ openDialog('SearchOverlay'); }); });
  $$('[data-mobile-menu-open]').forEach(function(b){ b.addEventListener('click', function(){ openDialog('MobileMenu'); }); });

  /* ---------------- Toast ---------------- */
  var toastEl = $('#Toast'), toastT;
  function toast(msg){
    if(!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastT);
    toastT = setTimeout(function(){ toastEl.classList.remove('show'); }, 3200);
  }

  /* ---------------- Money formatting (uses shop.money_format) ---------------- */
  function formatMoney(cents){
    var format = CART_SETTINGS.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var full = withComma + '.' + parts[1];
    var noDecimals = withComma;
    return format
      .replace('{{amount}}', full)
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{amount_with_comma_separator}}', full.replace('.', ','));
  }

  /* ---------------- Cart (Shopify Ajax API) ---------------- */
  var cartCountEls = $$('#CartCount, #CartDrawerCount');
  function bumpCount(){ $$('.count').forEach(function(c){ c.classList.add('bump'); setTimeout(function(){ c.classList.remove('bump'); }, 300); }); }

  function fetchCart(){
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); });
  }

  function renderCart(cart){
    var n = cart.item_count;
    $$('#CartCount').forEach(function(el){ el.textContent = n || ''; });
    var countEl = $('#CartDrawerCount'); if(countEl) countEl.textContent = n ? '(' + n + ')' : '';

    var shipBar = $('#CartShipBar');
    if(shipBar){
      if(!CART_SETTINGS.freeShippingEnabled || !n){ shipBar.hidden = true; }
      else{
        var threshold = (CART_SETTINGS.freeShippingThreshold || 0) * 100;
        var left = Math.max(0, threshold - cart.total_price);
        var pct = threshold ? Math.min(100, (cart.total_price / threshold) * 100) : 100;
        shipBar.hidden = false;
        shipBar.innerHTML = (left
          ? (CART_SETTINGS.strings.shipping_left || "You're {amount} away from free shipping").replace('{amount}', formatMoney(left))
          : (CART_SETTINGS.strings.shipping_unlocked || "You've unlocked free shipping"))
          + '<div class="bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '" aria-label="Free shipping progress"><i style="width:' + pct + '%"></i></div>';
      }
    }

    var body = $('#CartDrawerBody'), foot = $('#CartDrawerFoot');
    if(!body) return;

    if(!n){
      body.innerHTML = '<div style="padding:48px 0;text-align:center">'
        + '<h3 style="font-size:2rem;font-weight:800;margin-bottom:10px">' + esc(CART_SETTINGS.strings.empty_title) + '</h3>'
        + '<p class="lead" style="margin:0 auto 24px">' + esc(CART_SETTINGS.strings.empty_text) + '</p>'
        + '<div style="display:grid;gap:10px">'
        + '<a class="btn btn-primary" href="' + CART_SETTINGS.allProductsUrl + '" data-close>' + esc(CART_SETTINGS.strings.continue_shopping) + '</a>'
        + '</div></div>';
      if(foot) foot.hidden = true;
      return;
    }

    if(foot) foot.hidden = false;
    body.innerHTML = cart.items.map(function(item, i){
      var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2') + '" alt="' + esc(item.product_title) + '" loading="lazy" width="88" height="88">' : '';
      return '<div class="line" data-key="' + item.key + '">'
        + '<a class="media" href="' + item.url + '" style="aspect-ratio:1/1;border-radius:var(--radius-sm)">' + img + '</a>'
        + '<div><a href="' + item.url + '" style="font-weight:600;text-decoration:none">' + esc(item.product_title) + '</a>'
        + (item.variant_title ? '<small>' + esc(item.variant_title) + '</small>' : '')
        + '<div class="qty"><button type="button" data-cart-minus="' + item.key + '" aria-label="Decrease quantity">&minus;</button>'
        + '<span aria-live="polite">' + item.quantity + '</span>'
        + '<button type="button" data-cart-plus="' + item.key + '" aria-label="Increase quantity">+</button></div></div>'
        + '<div style="text-align:right"><div style="font-weight:600">' + formatMoney(item.final_line_price) + '</div>'
        + '<button class="rm" type="button" data-cart-remove="' + item.key + '">' + esc(CART_SETTINGS.strings.remove) + '</button></div>'
        + '</div>';
    }).join('');

    if(foot){
      foot.innerHTML = '<div class="sub"><span>' + esc(CART_SETTINGS.strings.subtotal) + '</span><span>' + formatMoney(cart.total_price) + '</span></div>'
        + '<p class="fine">' + esc(CART_SETTINGS.strings.taxes_shipping) + '</p>'
        + '<form action="' + CART_SETTINGS.cartUrl + '" method="post" id="CartCheckoutForm">'
        + '<button class="btn btn-accent btn-block" type="submit" name="checkout">' + esc(CART_SETTINGS.strings.checkout) + '</button>'
        + '</form>'
        + '<button class="btn btn-ghost btn-block" type="button" data-close>' + esc(CART_SETTINGS.strings.continue_shopping) + '</button>';
    }

    if(CART_SETTINGS.showRecommendations && cart.items.length){
      renderCartUpsell(cart);
    } else {
      var existingMini = document.getElementById('CartUpsell');
      if(existingMini) existingMini.remove();
    }
  }

  function renderCartUpsell(cart){
    var lastItem = cart.items[cart.items.length - 1];
    var inCart = cart.items.map(function(i){ return i.product_id; });
    fetch('/recommendations/products.json?product_id=' + lastItem.product_id + '&limit=6&intent=related', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(data){
        var picks = (data.products || []).filter(function(p){ return inCart.indexOf(p.id) === -1 && p.available; }).slice(0, 3);
        var body = $('#CartDrawerBody');
        var existing = document.getElementById('CartUpsell');
        if(existing) existing.remove();
        if(!picks.length || !body) return;
        var mini = document.createElement('div');
        mini.className = 'mini';
        mini.id = 'CartUpsell';
        mini.innerHTML = '<h3>' + esc(CART_SETTINGS.strings.you_may_also_like) + '</h3>' + picks.map(function(p){
          var img = p.featured_image ? '<img src="' + p.featured_image + '" alt="" loading="lazy" width="64" height="64" style="width:100%;height:100%;object-fit:cover">' : '';
          return '<div class="mini-row"><div class="media" style="aspect-ratio:1/1;border-radius:10px">' + img + '</div>'
            + '<div><b>' + esc(p.title) + '</b><span class="fine">' + formatMoney(p.price) + '</span></div>'
            + '<button class="btn btn-ghost" style="min-height:40px;padding:0 16px" data-quick-add data-product-handle="' + p.handle + '" aria-label="Choose options for ' + esc(p.title) + '">Add</button></div>';
        }).join('');
        body.appendChild(mini);
      }).catch(function(){});
  }

  function esc(s){ return (s || '').toString().replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  function addToCart(id, quantity, sellingPlan){
    var body = { id: id, quantity: quantity || 1 };
    if(sellingPlan) body.selling_plan = sellingPlan;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r){
      return r.json().then(function(data){
        if(!r.ok) throw data;
        return data;
      });
    });
  }

  function changeCart(key, quantity){
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function(r){ return r.json(); });
  }

  document.addEventListener('click', function(e){
    var minus = e.target.closest('[data-cart-minus]'), plus = e.target.closest('[data-cart-plus]'), rm = e.target.closest('[data-cart-remove]');
    if(minus || plus || rm){
      var key = (minus || plus || rm).dataset.cartMinus || (minus || plus || rm).dataset.cartPlus || (minus || plus || rm).dataset.cartRemove;
      fetchCart().then(function(cart){
        var item = cart.items.find(function(i){ return i.key === key; });
        var q = rm ? 0 : (minus ? Math.max(0, item.quantity - 1) : item.quantity + 1);
        changeCart(key, q).then(renderCart);
      });
    }
  });

  var cartForm = $('#CartCheckoutForm');
  document.addEventListener('submit', function(e){
    if(e.target && e.target.id === 'CartCheckoutForm'){
      /* Real Shopify checkout: let the native form submission go to routes.cart_url,
         which redirects to Shopify's checkout when the "checkout" button is used. */
    }
  });

  /* Quick add: fetch product JSON, open modal, add via /cart/add.js */
  function openQuickAdd(handle){
    fetch('/products/' + handle + '.js').then(function(r){ return r.json(); }).then(function(product){
      renderQuickAdd(product);
      openDialog('QuickAddDialog');
    });
  }

  function renderQuickAdd(product){
    var dialog = document.getElementById('QuickAddDialog');
    if(!dialog){
      dialog = document.createElement('dialog');
      dialog.id = 'QuickAddDialog';
      dialog.className = 'modal';
      dialog.innerHTML = '<div class="sheet" id="QuickAddBody"></div>';
      document.body.appendChild(dialog);
      dialog.addEventListener('cancel', function(e){ e.preventDefault(); closeDialog(dialog); });
      dialog.addEventListener('click', function(e){ if(e.target === dialog) closeDialog(dialog); });
    }
    var img = product.featured_image ? '<img src="' + product.featured_image + '" alt="' + esc(product.title) + '" style="width:100%;height:100%;object-fit:cover">' : '';
    var optionsHtml = product.options.map(function(opt, idx){
      var values = opt.values.map(function(v){
        var vid = 'qa-' + idx + '-' + v.replace(/\s+/g, '-');
        return '<input type="radio" name="option' + idx + '" id="' + vid + '" value="' + esc(v) + '"><label for="' + vid + '">' + esc(v) + '</label>';
      }).join('');
      return '<fieldset class="opt" data-option-index="' + idx + '"><legend>' + esc(opt.name) + '</legend><div class="opt-row">' + values + '</div></fieldset>';
    }).join('');

    var body = document.getElementById('QuickAddBody');
    body.innerHTML = '<div class="qv"><div class="media" id="QaMedia" style="aspect-ratio:1/1">' + img + '</div>'
      + '<div class="qv-info"><div style="display:flex;justify-content:space-between;gap:12px"><h2>' + esc(product.title) + '</h2>'
      + '<button class="icon-btn" data-close aria-label="Close">' + closeIconSvg() + '</button></div>'
      + '<div class="price" id="QaPrice" style="font-size:1.1rem">' + formatMoney(product.price) + '</div>'
      + '<form id="QaForm">' + optionsHtml
      + '<div class="err" id="QaErr" role="alert"></div>'
      + '<button class="btn btn-primary btn-block" type="submit">' + (product.available ? 'Add to bag' : 'Sold out') + '</button>'
      + '</form></div></div>';

    var form = $('#QaForm', body);
    function selectedVariant(){
      var selected = product.options.map(function(opt, idx){
        var checked = form.querySelector('input[name="option' + idx + '"]:checked');
        return checked ? checked.value : null;
      });
      if(selected.indexOf(null) > -1) return null;
      return product.variants.find(function(v){
        return v.options.every(function(val, i){ return val === selected[i]; });
      });
    }
    form.addEventListener('change', function(){
      var v = selectedVariant();
      $('#QaErr').textContent = '';
      if(v){
        $('#QaPrice').textContent = formatMoney(v.price);
        if(v.featured_image){ $('#QaMedia').innerHTML = '<img src="' + v.featured_image.src + '" alt="' + esc(product.title) + '" style="width:100%;height:100%;object-fit:cover">'; }
      }
    });
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var v = selectedVariant();
      if(!v){ $('#QaErr').textContent = 'Select all options to continue.'; return; }
      if(!v.available){ $('#QaErr').textContent = 'That combination is sold out.'; return; }
      addToCart(v.id, 1).then(function(){
        fetchCart().then(function(cart){
          renderCart(cart);
          bumpCount();
          closeDialog(document.getElementById('QuickAddDialog'));
          if(CART_SETTINGS.cartType === 'drawer'){ setTimeout(function(){ openDialog('CartDrawer'); }, reduceMotion ? 0 : 240); }
          else if(CART_SETTINGS.cartType === 'notification'){ toast(product.title + ' added to your bag.'); }
          else { window.location.href = CART_SETTINGS.cartUrl; }
        });
      }).catch(function(err){ $('#QaErr').textContent = (err && err.description) || 'Could not add this item to your bag.'; });
    });
  }
  function closeIconSvg(){ return '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg>'; }

  document.addEventListener('click', function(e){
    var q = e.target.closest('[data-quick-add]');
    if(q){ e.preventDefault(); openQuickAdd(q.dataset.productHandle); }
  });

  /* Main product form (product.liquid page) */
  var productForm = $('#ProductForm');
  if(productForm){
    var productJsonEl = $('#ProductJson');
    var product = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;

    function currentVariant(){
      if(!product) return null;
      var selected = $$('.opt', productForm).map(function(fs){
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      if(!selected.length) return product.variants[0];
      if(selected.indexOf(null) > -1) return null;
      return product.variants.find(function(v){ return v.options.every(function(val, i){ return val === selected[i]; }); });
    }

    /* Cache the server-rendered button label (correctly reflects pre-order vs
       regular add-to-cart from Liquid) so JS restores the right text rather
       than guessing when a variant becomes available again. */
    var addBtnLabel = $('#AddToCart [data-add-text]') ? $('#AddToCart [data-add-text]').textContent.trim() : 'Add to bag';

    /* Grey out / disable option values that have no available variant given the
       currently selected values in the other option groups, so shoppers can't
       pick an invalid or sold-out combination. */
    function updateOptionAvailability(){
      if(!product) return;
      var groups = $$('.opt', productForm);
      var selected = groups.map(function(fs){ var c = fs.querySelector('input:checked'); return c ? c.value : null; });
      groups.forEach(function(fs, idx){
        $$('input[data-option-value]', fs).forEach(function(input){
          var trial = selected.slice();
          trial[idx] = input.value;
          var hasAvailable = product.variants.some(function(v){
            return v.options.every(function(val, i){ return trial[i] == null || val === trial[i]; }) && v.available;
          });
          input.disabled = !hasAvailable;
        });
        var checked = fs.querySelector('input:checked');
        var label = $('[data-selected-value]', fs);
        if(label) label.textContent = checked ? ': ' + checked.value : '';
      });
    }
    updateOptionAvailability();

    function updateLowStock(v){
      var el = $('#ProductAvailability');
      if(!el) return;
      if(!v || !v.available){ el.textContent = 'Sold out'; return; }
      if(v.inventory_management === 'shopify' && v.inventory_policy === 'deny' && v.inventory_quantity > 0 && v.inventory_quantity <= 5){
        el.textContent = 'Only ' + v.inventory_quantity + ' left';
      } else {
        el.textContent = 'In stock, ready to ship';
      }
    }

    function goToMedia(mediaId){
      $$('.pp-slide').forEach(function(s){ s.classList.toggle('active', String(s.dataset.mediaId) === String(mediaId)); });
      $$('.pp-thumb').forEach(function(t){ t.classList.toggle('active', String(t.dataset.mediaId) === String(mediaId)); });
      var idx = $$('.pp-slide').findIndex(function(s){ return String(s.dataset.mediaId) === String(mediaId); });
      $$('.pp-dot').forEach(function(d, i){ d.classList.toggle('active', i === idx); });
    }

    productForm.addEventListener('change', function(){
      updateOptionAvailability();
      var v = currentVariant();
      var priceEl = $('[data-price]', productForm.parentNode);
      var stickyPriceEl = $('#ProductStickyBar [data-price]');
      var idInput = $('#ProductVariantId');
      var addBtn = $('#AddToCart');
      var stickyBtn = $('#StickyAddToCart');
      if(v){
        if(idInput) idInput.value = v.id;
        if(priceEl) priceEl.textContent = formatMoney(v.price);
        if(stickyPriceEl) stickyPriceEl.textContent = formatMoney(v.price);
        [addBtn, stickyBtn].forEach(function(btn){
          if(!btn) return;
          btn.disabled = !v.available;
          var label = $('[data-add-text]', btn);
          if(label) label.textContent = v.available ? addBtnLabel : 'Sold out';
        });
        updateLowStock(v);
        if(v.featured_media) goToMedia(v.featured_media.id);
      } else if(addBtn){
        addBtn.disabled = true;
      }
    });

    $$('.pp-thumb').forEach(function(t){
      t.addEventListener('click', function(){ goToMedia(t.dataset.mediaId); });
    });

    /* Swipeable mobile gallery: sync dots to native horizontal scroll snap */
    var ppMain = $('.pp-main');
    if(ppMain && matchMedia('(max-width: 899px)').matches){
      var slides = $$('.pp-slide');
      ppMain.style.display = 'flex';
      ppMain.style.overflowX = 'auto';
      ppMain.style.scrollSnapType = 'x mandatory';
      slides.forEach(function(s){ s.style.opacity = '1'; s.style.position = 'relative'; s.style.flex = '0 0 100%'; s.style.scrollSnapAlign = 'start'; });
      ppMain.addEventListener('scroll', function(){
        var idx = Math.round(ppMain.scrollLeft / ppMain.clientWidth);
        $$('.pp-dot').forEach(function(d, i){ d.classList.toggle('active', i === idx); });
        $$('.pp-thumb').forEach(function(t, i){ t.classList.toggle('active', i === idx); });
      }, { passive: true });
    }

    /* Zoom lightbox */
    document.addEventListener('click', function(e){
      var z = e.target.closest('[data-zoom-open]');
      if(!z) return;
      var img = z.querySelector('img');
      if(!img) return;
      $('#ZoomBody').innerHTML = '<img src="' + (img.dataset.zoomSrc || img.src) + '" alt="' + esc(img.alt) + '">';
      openDialog('ZoomDialog');
    });

    /* Sticky mobile add-to-cart: shows once the main form scrolls out of view */
    var stickyBar = $('#ProductStickyBar');
    if(stickyBar && 'IntersectionObserver' in window){
      var io2 = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ stickyBar.classList.toggle('show', !en.isIntersecting && innerWidth < 960); });
      }, { threshold: 0 });
      io2.observe(productForm);
    }
    var stickyBtn = $('#StickyAddToCart');
    if(stickyBtn){
      stickyBtn.addEventListener('click', function(){ productForm.requestSubmit ? productForm.requestSubmit() : $('#AddToCart').click(); });
    }

    $$('[data-qty-minus]', productForm).forEach(function(b){ b.addEventListener('click', function(){ var i = $('#Quantity'); i.value = Math.max(1, (+i.value) - 1); }); });
    $$('[data-qty-plus]', productForm).forEach(function(b){ b.addEventListener('click', function(){ var i = $('#Quantity'); i.value = (+i.value) + 1; }); });

    productForm.addEventListener('submit', function(e){
      e.preventDefault();
      var v = currentVariant();
      var err = $('#ProductFormError');
      if(!v){ err.textContent = 'Select all options to continue.'; return; }
      var qty = +($('#Quantity').value || 1);
      var addBtn = $('#AddToCart');
      var stickyBtnEl = $('#StickyAddToCart');
      addBtn.disabled = true;
      if(stickyBtnEl) stickyBtnEl.disabled = true;
      addToCart(v.id, qty).then(function(){
        err.textContent = '';
        fetchCart().then(function(cart){
          renderCart(cart);
          bumpCount();
          addBtn.disabled = false;
          if(stickyBtnEl) stickyBtnEl.disabled = false;
          if(CART_SETTINGS.cartType === 'drawer'){ openDialog('CartDrawer'); }
          else if(CART_SETTINGS.cartType === 'notification'){ toast(product.title + ' added to your bag.'); }
          else { window.location.href = CART_SETTINGS.cartUrl; }
        });
      }).catch(function(data){
        addBtn.disabled = false;
        if(stickyBtnEl) stickyBtnEl.disabled = false;
        err.textContent = (data && data.description) || 'Could not add this item to your bag.';
      });
    });
  }

  /* ---------------- Predictive search ---------------- */
  var psInput = $('#PredictiveSearchInput');
  if(psInput){
    var psTimer;
    psInput.addEventListener('input', function(){
      var q = psInput.value.trim();
      $('#SearchFullQuery').value = q;
      clearTimeout(psTimer);
      if(!q){ renderSearchEmpty(); return; }
      psTimer = setTimeout(function(){
        fetch(psInput.dataset.url + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=6', { headers: { 'Accept': 'application/json' } })
          .then(function(r){ return r.json(); })
          .then(function(data){ renderSearchResults(q, data.resources.results); })
          .catch(function(){});
      }, 220);
    });
    $('#SearchFullForm').addEventListener('submit', function(e){
      if(!psInput.value.trim()) e.preventDefault();
    });
  }
  function renderSearchEmpty(){
    var el = $('#PredictiveSearchResults');
    if(el) el.innerHTML = '<h3>Popular searches</h3><div class="s-tags">'
      + ['leggings','jacket','shorts','sports bra','tee'].map(function(s){ return '<button class="chip" type="button" data-suggest="' + s + '">' + s + '</button>'; }).join('')
      + '</div>';
  }
  function renderSearchResults(q, results){
    var el = $('#PredictiveSearchResults');
    if(!el) return;
    var products = results.products || [];
    var collections = results.collections || [];
    if(!products.length && !collections.length){
      el.innerHTML = '<div class="empty"><b>No results for \u201c' + esc(q) + '\u201d.</b>Check the spelling or try a broader term.</div>';
      return;
    }
    var html = '';
    if(products.length){
      html += '<h3>Products</h3>' + products.map(function(p){
        return '<a class="s-item" href="' + p.url + '"><span class="media" style="width:64px;height:64px;border-radius:10px">' + (p.image ? '<img src="' + p.image + '" alt="" width="64" height="64" style="width:100%;height:100%;object-fit:cover">' : '') + '</span><span><b style="font-weight:600">' + esc(p.title) + '</b></span><span>' + p.price + '</span></a>';
      }).join('');
    }
    if(collections.length){
      html += '<h3>Collections</h3><div class="s-tags">' + collections.map(function(c){ return '<a class="chip" href="' + c.url + '">' + esc(c.title) + '</a>'; }).join('') + '</div>';
    }
    el.innerHTML = html;
  }
  document.addEventListener('click', function(e){
    var s = e.target.closest('[data-suggest]');
    if(s){ psInput.value = s.dataset.suggest; psInput.dispatchEvent(new Event('input')); psInput.focus(); }
  });

  /* ---------------- Header scroll + sticky mobile CTA ---------------- */
  var hdr = $('#SiteHeader');
  var stickyCta = $('#StickyCta');
  var ticking = false;
  addEventListener('scroll', function(){
    if(ticking) return;
    ticking = true;
    requestAnimationFrame(function(){
      if(hdr) hdr.classList.toggle('scrolled', scrollY > 40);
      if(stickyCta) stickyCta.classList.toggle('show', scrollY > innerHeight * 0.9);
      ticking = false;
    });
  }, { passive: true });

  /* ---------------- Scroll reveal ---------------- */
  if('IntersectionObserver' in window && !reduceMotion){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    $$('[data-animate]').forEach(function(el){ el.classList.add('reveal'); io.observe(el); });
  }

  /* ---------------- Product recommendations (product page) ---------------- */
  var recEl = $('#ProductRecommendations');
  if(recEl && recEl.dataset.url && !recEl.children.length){
    fetch(recEl.dataset.url)
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('ProductRecommendations');
        if(fresh) recEl.innerHTML = fresh.innerHTML;
      }).catch(function(){});
  }

  /* ---------------- Init ---------------- */
  fetchCart().then(renderCart);
})();
